import { Controller } from "@hotwired/stimulus"
import mediumZoom from "medium-zoom"

export default class extends Controller {
  static targets = ["image"]
  static values = {
    margin: { type: Number, default: 24 },       // gap around the zoomed image
    background: String,                          // e.g. "rgba(0,0,0,.9)"
    scrollOffset: { type: Number, default: 40 }, // px to scroll before closing
    container: String                            // CSS selector for custom container
  }

  connect() {
    const opts = {
      margin: this.marginValue,
      scrollOffset: this.scrollOffsetValue,
      ...(this.hasBackgroundValue ? { background: this.backgroundValue } : {}),
      ...(this.hasContainerValue ? { container: document.querySelector(this.containerValue) } : {})
    }

    // If there are explicit targets, use them; otherwise use the root element.
    const elements = this.imageTargets.length ? this.imageTargets : [this.element]

    this.zoom = mediumZoom(elements, opts)
  }

  disconnect() {
    if (this.zoom) this.zoom.detach()
  }
}
